import { render, staticRenderFns } from "./ColorSizeDialog.vue?vue&type=template&id=14286088&"
import script from "./ColorSizeDialog.vue?vue&type=script&lang=js&"
export * from "./ColorSizeDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports